<template>
  <div id="BusinessMgmt" style="margin: 0 auto; background: white">
    <div ref="header" class="header-box">
      <div class="header-line">
        <span class="header-label">视图类型</span>
        <el-select placeholder="视图类型" size="small" v-model="params.viewType">
          <el-option label="SKU" value="1"></el-option>
          <el-option label="产品" value="2"></el-option>
          <el-option label="产品-颜色" value="3"></el-option>
          <el-option label="机型" value="4"></el-option>
          <el-option label="产品-机型" value="5"></el-option>
        </el-select>
        <span class="header-label">产品类型</span>
        <el-select placeholder="产品类型" size="small" v-model="params.productType" filterable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
        </el-select>
        <span class="header-label">产品颜色</span>
        <el-select placeholder="产品类型" size="small" v-model="params.productColor" filterable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
        </el-select>
        <span class="header-label">机型</span>
        <el-select placeholder="机型" size="small" v-model="productModel">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
        </el-select>
        <span class="header-label">SKU</span>
        <el-input placeholder="请输入SKU" size="small" clearable v-model="params.sku"> </el-input>
        <!-- <span class="header-label">商品类型</span>
        <el-select placeholder="请选择" size="small" v-model="params.fulfillmentChannel">
          <el-option label="全部" value=""></el-option>
          <el-option label="FBA" value="AMAZON_NA"></el-option>
          <el-option label="自发货" value="DEFAULT"></el-option>
        </el-select> -->
        <span class="header-label">排序类型</span>
        <el-select placeholder="请选择" size="small" v-model="params.sortKey">
          <el-option label="增速" value="speed"></el-option>
          <el-option label="库存天数" value="inventoryDay"></el-option>
          <el-option label="库存数量" value="inventoryCount"></el-option>
          <el-option label="合计访客" value="totalVisit"></el-option>
          <el-option label="转化率" value="orderRate"></el-option>
          <el-option label="采购数量" value="recommendCount"></el-option>
          <el-option label="合计订单数" value="sum"></el-option>
        </el-select>
      </div>
      <div class="header-line">
        <span class="header-label">展示类型</span>
        <el-select placeholder="请选择" size="small" v-model="params.listShowType">
          <el-option label="销量" value="3"></el-option>
          <el-option label="销量-访客" value="5"></el-option>
          <el-option label="销量-毛利" value="12"></el-option>
          <el-option label="销量-净利" value="10"></el-option>
          <el-option label="销量-价格" value="4"></el-option>
          <el-option label="销量-毛利-广告-净利" value="11"></el-option>
          <el-option label="销量-订单量" value="9"></el-option>
          <el-option label="访客" value="2"></el-option>
          <el-option label="销量-价格-访客" value="6"></el-option>
          <el-option label="销量-访客-广告" value="8"></el-option>
          <el-option label="价格" value="1"></el-option>
          <el-option label="广告" value="7"></el-option>
        </el-select>
        <span class="header-label">日期</span>
        <el-date-picker v-model="params.date" type="date" placeholder="选择日期" style="margin-left: 5px; margin-right: 15px"> </el-date-picker>
        <span class="header-label">视图模式</span>
        <el-select placeholder="请选择" size="small" v-model="params.viewModel">
          <el-option label="精简" value="1"></el-option>
          <el-option label="全量" value="2"></el-option>
        </el-select>
        <span class="header-label">增速排序</span>
        <el-select placeholder="请选择" size="small" v-model="params.sortType">
          <el-option label="升序" value="1"></el-option>
          <el-option label="降序" value="-1"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="queryBtn">查询</el-button>
        <el-button type="primary" size="small" @click="importBtn">导入</el-button>
        <el-button type="primary" size="small" @click="exportProductBtn">导出</el-button>
        <el-button type="primary" size="small" @click="createAdvertBtn">生成广告</el-button>

        <el-button type="primary" size="small" @click="createKeywordBtn" style="display: none">生成关键词广告</el-button>
        <el-button type="primary" size="small" @click="createBtn">生成数据</el-button>
      </div>
    </div>
    <el-table ref="table" :data="tableData" stripe size="mini" :height="screenHeight" :highlight-current-row="true">
      <el-table-column v-if="params.viewType == 1" prop="seller-sku" label="SKU" width="200px" align="center" :key="10" fixed sortable> </el-table-column>
      <el-table-column v-if="params.viewType != 4" prop="productName" label="名称" width="80px" align="right" :key="11" fixed sortable> </el-table-column>
      <el-table-column v-if="params.viewType == 1 || params.viewType == 4 || params.viewType == 5" prop="model" label="机型" width="60px" align="right" :key="12" sortable> </el-table-column>
      <el-table-column v-if="params.viewType == 1 || params.viewType == 3" prop="productColorName" label="颜色" width="40px" align="right" :key="13" sortable> </el-table-column>
      <!-- <el-table-column prop="fulfillment-channel" label="类型" width="40px" align="right" v-if="params.viewModel == 2" :key="14" sortable>
        <template v-slot="scope">
          <div class="row-item">{{ scope.row["fulfillment-channel"] && (scope.row["fulfillment-channel"] == "AMAZON_NA"? "FBA":"自发货") }}</div>
        </template>
      </el-table-column> -->
      <el-table-column prop="speed" label="增速" width="40px" align="right" :key="15" sortable> </el-table-column>
      <el-table-column v-if="params.viewModel == 2" prop="inventoryAge0To90Days" label="0~90日库存" width="40px" align="right" :key="16" sortable> </el-table-column>
      <el-table-column v-if="params.viewModel == 2" prop="inventoryAge91To180Days" label="91~180日库存" width="40px" align="right" :key="17" sortable>
        <template v-slot="scope">
          <div :class="getInventoryAgeStyleClass(scope.row.inventoryAge91To180Days)">{{ scope.row.inventoryAge91To180Days }}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="params.viewModel == 2" prop="sellThrough" label="售出率" width="40px" align="right" :key="18" sortable>
        <template v-slot="scope">
          <div :class="getSellThroughStyleClass(scope.row.sellThrough)">{{ scope.row.sellThrough }}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="params.viewModel == 2" prop="unitsShippedT90" label="90日订单" width="60px" align="right" :key="19" sortable> </el-table-column>

      <el-table-column prop="inventoryCount" label="库存" width="40px" align="right" :key="111" sortable> </el-table-column>
      <el-table-column prop="availableQuantity" label="可用" width="40px" style="color: green" align="right" :key="112" sortable>
        <template v-slot="scope">
          <div class="greenText">{{ scope.row.availableQuantity }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="reservedQuantity" label="预留" width="40px" style="color: greenyellow" align="right" :key="113" sortable>
        <template v-slot="scope">
          <div class="greenYellowText">{{ scope.row.reservedQuantity }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="inboundQuantity" label="入库" width="40px" align="right" :key="114" sortable> </el-table-column>
      <el-table-column prop="availableIn1WeekCount" label="1周内上架" width="40px" align="right" :key="81151" sortable
        ><template v-slot="scope">
          <div>{{ scope.row.availableIn1WeekCount > 0 ? scope.row.availableIn1WeekCount : "-" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableIn2WeekCount" label="2周内上架" width="40px" align="right" :key="81152" sortable
        ><template v-slot="scope">
          <div>{{ scope.row.availableIn2WeekCount > 0 ? scope.row.availableIn2WeekCount : "-" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableIn3WeekCount" label="3周内上架" width="40px" align="right" :key="81153" sortable
        ><template v-slot="scope">
          <div>{{ scope.row.availableIn3WeekCount > 0 ? scope.row.availableIn3WeekCount : "-" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableIn4WeekCount" label="4周内上架" width="40px" align="right" :key="81154" sortable
        ><template v-slot="scope">
          <div>{{ scope.row.availableIn4WeekCount > 0 ? scope.row.availableIn4WeekCount : "-" }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="availableIn5WeekCount" label="5周内上架" width="40px" align="right" :key="81155" sortable
        ><template v-slot="scope">
          <div>{{ scope.row.availableIn5WeekCount > 0 ? scope.row.availableIn5WeekCount : "-" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableOver5WeekCount" label="超5周上架" width="40px" align="right" :key="81156" sortable
        ><template v-slot="scope">
          <div>{{ scope.row.availableOver5WeekCount > 0 ? scope.row.availableOver5WeekCount : "-" }}</div>
        </template>
      </el-table-column> -->

      <el-table-column prop="reservedFutureSupply" label="买家订单" width="40px" align="right" :key="31151" sortable> </el-table-column>
      <el-table-column prop="researchingQuantity" label="调查中" width="40px" align="right" :key="31152" sortable> </el-table-column>
      <!-- <el-table-column prop="reservedFutureSupply" label="买家订单" width="40px" align="right" :key="31153" sortable> </el-table-column> -->
      <el-table-column prop="unsellableQuantity" label="不可售" width="40px" align="right" :key="31154" sortable> </el-table-column>
      <el-table-column prop="localInventory" label="本地库存" width="40px" align="right" :key="311155" sortable> </el-table-column>
      <el-table-column prop="inPurchase" label="采购中" width="40px" align="right" :key="31155" sortable> </el-table-column>
      <el-table-column prop="totalAwdUnits" label="AWD库存" width="40px" align="right" :key="32115511" sortable> </el-table-column>
      <el-table-column prop="inboundToAwdUnits" label="入库至AWD" width="40px" align="right" :key="131155" sortable> </el-table-column>
      <el-table-column prop="availableInAwdUnits" label="在AWD中可用" width="40px" align="right" :key="32115522" sortable> </el-table-column>
      <el-table-column prop="outboundToFbaUnits" label="AWD发往FBA" width="40px" align="right" :key="32115533" sortable> </el-table-column>
      <el-table-column prop="warehouseQuantity" label="全部库存" width="40px" align="right" :key="311535" sortable> </el-table-column>

      <el-table-column prop="inboundWorking" label="处理中" width="40px" align="right" :key="115" sortable> </el-table-column>
      <el-table-column prop="inboundShipped" label="已发货" width="40px" align="right" :key="116" sortable> </el-table-column>
      <el-table-column prop="inboundReceived" label="正在接收" width="40px" align="right" :key="117" sortable> </el-table-column>
      <el-table-column prop="dayOrderItems" label="日销量" width="45px" style="color: greenyellow" align="right" :key="1113" sortable>
        <template v-slot="scope">
          <div class="greenYellowText">{{ scope.row.dayOrderItems ? scope.row.dayOrderItems.toFixed(2) : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="inventoryDay" label="库存天数" width="55px" align="right" :key="118" sortable>
        <template v-slot="scope">
          <div :class="getInventoryDayStyleClass(scope.row.inventoryDay)">{{ scope.row.inventoryDay }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableInventoryDay" label="可用库存天数" width="55px" align="right" :key="1118" sortable>
        <template v-slot="scope">
          <div :class="getInventoryDayStyleClass(scope.row.availableInventoryDay)">{{ scope.row.availableInventoryDay }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="recommendCount" label="采购" width="40px" align="right" v-if="params.viewModel == 2" :key="119" sortable> </el-table-column>
      <el-table-column prop="totalVisit" label="30日访客" width="55px" align="right" :key="120" sortable> </el-table-column>
      <el-table-column prop="last7DayVisit" label="7日访客" width="55px" align="right" :key="150" sortable> </el-table-column>
      <!-- <el-table-column prop="orderRate" label="90日转化率" width="45px" align="right" :key="1121" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.orderRate >= 0 ? (Math.round(scope.row.orderRate * 10000) / 100).toFixed(2) + "%" : "" }}</div>
        </template>
      </el-table-column> -->
      <el-table-column prop="orderRate" label="30日转化率" width="45px" align="right" :key="121" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.orderRate >= 0 ? (Math.round(scope.row.orderRate * 10000) / 100).toFixed(2) + "%" : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="last7DayOrderRate" label="7日转化率" width="45px" align="right" :key="151" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.last7DayOrderRate >= 0 ? (Math.round(scope.row.last7DayOrderRate * 10000) / 100).toFixed(2) + "%" : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="totalGrossProfit" label="30日毛利" width="55px" align="right" :key="33151" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.totalGrossProfit ? scope.row.totalGrossProfit.toFixed(2) : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="totalNetProfit" label="30日净利" width="55px" align="right" :key="323151" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.totalGrossProfit ? scope.row.totalNetProfit.toFixed(2) : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="rank" label="排名" width="60px" align="right" :key="122"> </el-table-column>
      <el-table-column prop="score" label="评分" width="30px" align="right" :key="1223342">
        <template v-slot="scope">
          <div>{{ scope.row.score ? (scope.row.score / 10000).toFixed(1) : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="competitionRank" label="竞品排名" width="60px" align="right" :key="1222" sortable> </el-table-column>
      <el-table-column prop="last30DayCount" label="30日订单" width="60px" align="right" :key="123" sortable> </el-table-column>
      <el-table-column prop="last7DayCount" label="7日订单" width="60px" align="right" :key="124" sortable> </el-table-column>
      <el-table-column prop="price" label="价格" width="40px" align="right" :key="125" sortable> </el-table-column>
      <el-table-column prop="competitionUnitPrice" label="竞品价格" width="40px" align="right" :key="1225" sortable> </el-table-column>
      <el-table-column prop="recommendPrice" label="推荐价格" width="55px" align="right" v-if="params.viewModel == 2" :key="126" sortable>
        <template v-slot="scope">
          <div :class="getRecommendPriceStyleClass(scope.row)">{{ scope.row.recommendPrice }}</div>
        </template>
      </el-table-column>
      <el-table-column label="广告状态" width="60px" align="right" v-if="params.viewModel == 2" :key="127">
        <template v-slot="scope">
          <el-switch v-if="scope.row['seller-sku'].indexOf('合计') == -1 && params.viewType == 1" v-model="scope.row.adState" active-value="已启用" inactive-value="已暂停" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80px" :key="128">
        <template slot-scope="scope">
          <el-button v-if="scope.row['seller-sku'].indexOf('合计') == -1 && params.viewType == 2" type="text" size="small" @click="productDetail(scope.row)">详情</el-button>
          <el-button v-if="scope.row['seller-sku'].indexOf('合计') == -1 && params.viewType == 1" type="text" size="small" @click="goAdvert(scope.row)">广告</el-button>
          <span v-if="scope.$index == 0">访客</span>
          <span v-if="scope.$index == 1">销量</span>
          <span v-if="scope.$index == 2">销售额</span>
          <span v-if="scope.$index == 3">毛利</span>
          <span v-if="scope.$index == 4">退货毛利</span>
          <span v-if="scope.$index == 5">退货费</span>
          <span v-if="scope.$index == 6">广告</span>
          <span v-if="scope.$index == 7">净利</span>
        </template>
      </el-table-column>
      <el-table-column v-for="(date, index) in dateList" :key="date" :label="date" width="50px" sortable>
        <template v-slot="scope">
          <div v-if="scope.row['seller-sku'].indexOf('合计') != -1">
            <div class="row-item">{{ scope.row["orderItemsCount" + (index + 1)] }}</div>
          </div>
          <template v-else>
            <div class="row-item" v-if="params.listShowType == 3 || params.listShowType == 4 || params.listShowType == 5 || params.listShowType == 6 || params.listShowType == 8 || params.listShowType == 9 || params.listShowType == 10 || params.listShowType == 11 || params.listShowType == 12">
              {{ scope.row["orderItemsCount" + (index + 1)] }}
            </div>
            <div class="row-item" v-if="params.listShowType == 2 || params.listShowType == 5 || params.listShowType == 6 || params.listShowType == 8">{{ scope.row["totalVisit" + (index + 1)] }}</div>
            <div class="row-item" v-if="params.listShowType == 1 || params.listShowType == 4 || params.listShowType == 6">
              {{ Number(scope.row["averagePrice" + (index + 1)]) > 0 ? Number(scope.row["averagePrice" + (index + 1)]).toFixed(2) : 0 }}
            </div>
            <div class="row-item" v-if="params.listShowType == 9">{{ scope.row["orderCount" + (index + 1)] }}</div>
            <div class="row-item" v-if="params.listShowType == 12 || params.listShowType == 11">{{ scope.row["grossProfit" + (index + 1)].toFixed(2) }}</div>
            <div class="row-item" v-if="params.listShowType == 7 || params.listShowType == 8 || params.listShowType == 11">{{ Number(scope.row["adSpend" + (index + 1)]).toFixed(2) }}</div>
            <div class="row-item" v-if="params.listShowType == 10 || params.listShowType == 11">{{ scope.row["netProfit" + (index + 1)].toFixed(2) }}</div>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick"> </el-pagination>
    <el-dialog title="导入" :visible.sync="dialogFormVisible" width="35%">
      <el-form :model="form">
        <el-form-item label="导入订单" label-width="80">
          <el-upload ref="uploadOrder" class="upload-demo" action="/node/importOrder" :data="{ shopType }" :auto-upload="false" :on-success="onUploadSuccess" :before-upload="beforeUpload" :limit="1">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入亚马逊物流库存" label-width="80">
          <el-upload ref="uploadInventory" class="upload-demo" action="/node/importInventory" :data="{ shopType }" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入管理亚马逊物流库存" label-width="80">
          <el-upload ref="uploadFBAInventory" class="upload-demo" action="/node/importFBAInventory" :data="{ shopType }" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入访问报告" label-width="80">
          <el-date-picker v-model="visitForm.visitDate" type="date" placeholder="选择日期" style="vertical-align: top" :on-success="onUploadSuccess" :before-upload="beforeUpload"> </el-date-picker>
          <el-upload ref="uploadVisit" class="upload-demo" action="/node/importVisitManul" :data="visitForm" :auto-upload="false" :limit="1" style="display: inline-block; vertical-align: middle; float: right" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入交易" label-width="80">
          <el-upload ref="uploadTrade" class="upload-demo" action="/node/importTrade" :data="{ shopType }" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入产品" label-width="80">
          <el-upload ref="uploadProduct" class="upload-demo" action="/node/importProduct" :data="{ shopType }" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入批量操作推广表格" label-width="80">
          <el-upload ref="importAdvert" class="upload-demo" action="/node/importAdvert" :data="{ shopType }" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入搜索词报告" label-width="80">
          <el-upload ref="uploadKeywordAd" class="upload-demo" action="/node/importKeywordAd" :data="{ shopType }" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入投放报告" label-width="80">
          <el-upload ref="uploadDeliveryAd" class="upload-demo" action="/node/importDeliveryAd" :data="{ shopType }" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入商品推广报告" label-width="80">
          <el-upload ref="uploadProductAd" class="upload-demo" action="/node/importProductAd" :data="{ shopType }" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入广告位报告" label-width="80">
          <el-upload ref="advertSpace" class="upload-demo" action="/node/importAdvertSpace" :data="{ shopType }" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入退货订单" label-width="80">
          <el-upload ref="uploadReturnOrder" class="upload-demo" action="/node/importReturnOrder" :data="{ shopType }" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入费用" label-width="80">
          <el-upload ref="uploadFbaFee" class="upload-demo" action="/node/importFbaFee" :data="{ shopType }" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入销量流量表" label-width="80">
          <el-upload ref="uploadSalesTrafficReport" class="upload-demo" action="/node/importSalesTrafficReport" :data="{ shopType }" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload"> <el-button size="small" type="primary">点击上传</el-button> </el-upload>
        </el-form-item>
        <el-form-item label="导入热门搜索词" label-width="80">
          <el-upload ref="uploadHotKeyword" class="upload-demo" action="/node/importHotSearchKeyword" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入关键词搜索量" label-width="80">
          <el-upload ref="keywordSearchVolume" class="upload-demo" action="/node/importKeywordSearchVolume" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入西柚关键词" label-width="80">
          <el-upload ref="xiYouSearchKeyword" class="upload-demo" action="/node/importKeywordRank" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入月度仓储费" label-width="80">
          <el-upload ref="uploadMonthStoreFee" class="upload-demo" action="/node/importMonthStoreFee" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入Temu库存报告" label-width="80">
          <el-upload ref="uploadTemuInventory" class="upload-demo" action="/node/importTemuInventory" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入AWD库存报告" label-width="80">
          <el-upload ref="uploadAWDInventory" class="upload-demo" action="/node/importAWDInventory" accept=".csv" :data="{ shopType }" :auto-upload="false" :limit="1" :on-success="onUploadSuccess" :on-error="onUploadError" :before-upload="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="importData">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导出" :visible.sync="dialogProductVisible" width="25%">
      <el-form :model="form">
        <el-form-item label="库存规划" label-width="80">
          <el-button type="primary" size="small">
            <download-excel :data="exportBusinessDataList" :fields="exportTitles" :name="getExportName()">导出库存</download-excel>
          </el-button>
        </el-form-item>
        <el-form-item label="广告信息" label-width="80">
          <el-button type="primary" size="small">
            <download-excel :data="advertData" :fields="advertTitles" :name="getAdvertName()">导出广告</download-excel>
          </el-button>
        </el-form-item>
        <el-form-item label="新品信息" label-width="80">
          <el-button type="primary" size="small">
            <download-excel :data="productData" :fields="productTitles" :name="getExportProductName()">导出商品</download-excel>
          </el-button>
        </el-form-item>
        <el-form-item label="低销量产品" label-width="80">
          <el-button type="primary" size="small">
            <download-excel :data="lowSaleData" :fields="lowSaleTitles" :name="getExportProductName()">导出低销量商品</download-excel>
          </el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogProductVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { products, activeProducts, colors, models, PrettyFlower, FlowerBear, FashionJacket, DownJacket, PinkBear, FoldTinfoil, OilPaint, BasicMagnetic, WaveGlitter, ReflectSliver, ZebraStripe, WavyRipple, OilPaints, MagnetStand, PeonyRose, BasicClear, BaseSolid, BaseClear, SolidMagnetic, BorderDiamond } from "../../utils/constant.js";
import Utils from "../../utils/utils.js";

import { MessageBox } from "element-ui";
export default {
  data() {
    return {
      shopType: localStorage.getItem("shopType"),
      total: 0,
      pageCount: 1,
      importOptions: [
        {
          value: 1,
          label: "订单数据",
        },
        {
          value: 2,
          label: "交易数据",
        },
        {
          value: 3,
          label: "产品数据",
        },
      ],
      productList: activeProducts,
      colorList: colors,
      modelList: models,
      dialogFormVisible: false,
      dialogProductVisible: false,
      form: {
        file: null,
        type: 0,
      },
      totalPage: 1,
      businessDataList: [],
      exportBusinessDataList: [],
      dateList: [],
      activeRowIndex: -1,
      activeColumnIndex: -1,
      productModel: "",
      params: {
        sku: "",
        sortKey: "speed",
        sortType: "1",
        // fulfillmentChannel: "AMAZON_NA",
        viewType: "2",
        productType: "",
        productColor: "",
        date: new Date(),
        listShowType: "3",
        productModel: "",
        beginIndex: 0,
        viewModel: "1",
        pageSize: 10000,
      },
      visitForm: {
        visitDate: new Date().format("yyyy-MM-dd"),
      },
      advertData: [],
      exportProductInfo: {
        baseSku: "Gloomy-Round-",
        // models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
        models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11"],
        colors: [""],
        title: "IAIYOXI Phone Case Compatible with iPhone _model_ Cool Army Green 3D Bear Pattern,Fashion Round Corners Desigin,Slim TPU Case, Shockproof,Full Body Protection Case/Cover/Skin for Boy Men",
        desList: [
          "❤【Compatible model】 The phone case Only Compatible with iphone _model_",
          "❤【Cool 3D Bear】 Fashion Funny Kawaii cartoon graffiti skin phone case cover with Armygreen camo 3D bear pattern character,very stylish and unique,let you look different.Street trend and fashion lovers must have item",
          "❤【DESIGN】 Fashion Round Corners design with flexible plastic material and IMD technology - easily install and remove, without damaging or scratching the phone body. Phone case is thin and lightweight for flexible durability.",
          "❤【COLOR & FINISH】 Semi-gloss finish with unparalleled graphic printing technology, Vivid bright print technology that will not fade.",
          "❤【Full Body Protection】 Raised edges for extra protection of screen and camera - slim fit with sleek design. This stunning case makes the perfect fashion-forward gift for your loved ones.",
        ],
      },
      uploadCount: 0,
      importErrorMessage: "",
      screenHeight: document.body.clientHeight - 64 - 132 - 68 > 400 ? document.body.clientHeight - 64 - 132 - 68 : 400,
    };
  },
  components: {},
  watch: {
    "params.viewModel": {
      handler(val, olVal) {
        this.initDateList();
      },
      deep: true,
    },
    productModel: {
      handler: function (newValue, oldValue) {
        let blankReg = new RegExp(" ", "igm");
        let productModel = newValue.replace(blankReg, "");
        this.params.productModel = productModel;
      },
    },
    "params.viewType": {
      handler: function (newValue, oldValue) {
        this.params.pageSize = newValue == 1 ? 200 : 10000;
      },
      deep: true,
    },
    "params.productType": {
      handler: function (newValue, oldValue) {
        let parentProduct = this.productList.find(pd => pd.productType == newValue);
        let checkColors = Array.isArray(parentProduct.checkColors) ? parentProduct.checkColors : JSON.parse(parentProduct.checkColors);
        let checkModels = JSON.parse(parentProduct.checkModels);

        this.colorList = [];
        this.modelList = [...checkModels];

        colors.forEach(color => checkColors.includes(color.key) && this.colorList.push(color));
      },
    },
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  mounted() {
    this.initDateList();
    this.getData();

    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 132 - 68 > 400 ? document.body.clientHeight - 64 - 132 - 68 : 400;
    },
    queryBtn() {
      this.getData();
    },
    importBtn() {
      this.uploadCount = 0;
      this.importErrorMessage = "";
      this.dialogFormVisible = true;
    },
    exportProductBtn() {
      this.dialogProductVisible = true;

      this.getAdvertData();
      // this.getExportData();

      requestModules.updateProductRank(this.params).then(res => {});
    },
    importData() {
      this.importErrorMessage = "";
      this.dialogFormVisible = false;

      this.$refs.uploadOrder.uploadFiles.length > 0 && this.$refs.uploadOrder.submit();
      this.$refs.uploadTrade.uploadFiles.length > 0 && this.$refs.uploadTrade.submit();
      this.$refs.uploadProduct.uploadFiles.length > 0 && this.$refs.uploadProduct.submit();
      this.$refs.uploadInventory.uploadFiles.length > 0 && this.$refs.uploadInventory.submit();
      this.$refs.uploadFBAInventory.uploadFiles.length > 0 && this.$refs.uploadFBAInventory.submit();
      this.$refs.uploadVisit.uploadFiles.length > 0 && this.$refs.uploadVisit.submit();
      this.$refs.importAdvert.uploadFiles.length > 0 && this.$refs.importAdvert.submit();
      this.$refs.uploadProductAd.uploadFiles.length > 0 && this.$refs.uploadProductAd.submit();
      this.$refs.uploadKeywordAd.uploadFiles.length > 0 && this.$refs.uploadKeywordAd.submit();
      this.$refs.uploadDeliveryAd.uploadFiles.length > 0 && this.$refs.uploadDeliveryAd.submit();
      this.$refs.uploadReturnOrder.uploadFiles.length > 0 && this.$refs.uploadReturnOrder.submit();
      this.$refs.uploadFbaFee.uploadFiles.length > 0 && this.$refs.uploadFbaFee.submit();
      this.$refs.uploadHotKeyword.uploadFiles.length > 0 && this.$refs.uploadHotKeyword.submit();
      this.$refs.uploadMonthStoreFee.uploadFiles.length > 0 && this.$refs.uploadMonthStoreFee.submit();
      this.$refs.advertSpace.uploadFiles.length > 0 && this.$refs.advertSpace.submit();
      this.$refs.uploadTemuInventory.uploadFiles.length > 0 && this.$refs.uploadTemuInventory.submit();
      this.$refs.uploadAWDInventory.uploadFiles.length > 0 && this.$refs.uploadAWDInventory.submit();
      this.$refs.uploadSalesTrafficReport.uploadFiles.length > 0 && this.$refs.uploadSalesTrafficReport.submit();
      this.$refs.keywordSearchVolume.uploadFiles.length > 0 && this.$refs.keywordSearchVolume.submit();
      this.$refs.xiYouSearchKeyword.uploadFiles.length > 0 && this.$refs.xiYouSearchKeyword.submit();
    },
    beforeUpload() {
      this.uploadCount++;
      console.log("beforeUpload", this.uploadCount);
    },
    onUploadSuccess(response) {
      this.uploadCount--;
      if (response && response.code != null && response.code !== 0) {
        this.importErrorMessage = response.message || "导入失败";
      }
      if (this.uploadCount == 0) {
        this.finishImport();
      }
    },
    onUploadError() {
      this.uploadCount--;
      this.importErrorMessage = this.importErrorMessage || "导入失败";
      if (this.uploadCount == 0) {
        this.finishImport();
      }
    },
    finishImport() {
      const message = this.importErrorMessage || "导入完成";
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        this.clearUploadedFiles();
      });
    },
    clearUploadedFiles() {
      this.$refs.uploadOrder.uploadFiles.length > 0 && this.$refs.uploadOrder.clearFiles();
      this.$refs.uploadTrade.uploadFiles.length > 0 && this.$refs.uploadTrade.clearFiles();
      this.$refs.uploadProduct.uploadFiles.length > 0 && this.$refs.uploadProduct.clearFiles();
      this.$refs.uploadInventory.uploadFiles.length > 0 && this.$refs.uploadInventory.clearFiles();
      this.$refs.uploadFBAInventory.uploadFiles.length > 0 && this.$refs.uploadFBAInventory.clearFiles();
      this.$refs.uploadVisit.uploadFiles.length > 0 && this.$refs.uploadVisit.clearFiles();
      this.$refs.importAdvert.uploadFiles.length > 0 && this.$refs.importAdvert.clearFiles();
      this.$refs.uploadProductAd.uploadFiles.length > 0 && this.$refs.uploadProductAd.clearFiles();
      this.$refs.uploadKeywordAd.uploadFiles.length > 0 && this.$refs.uploadKeywordAd.clearFiles();
      this.$refs.uploadDeliveryAd.uploadFiles.length > 0 && this.$refs.uploadDeliveryAd.clearFiles();
      this.$refs.uploadReturnOrder.uploadFiles.length > 0 && this.$refs.uploadReturnOrder.clearFiles();
      this.$refs.uploadFbaFee.uploadFiles.length > 0 && this.$refs.uploadFbaFee.clearFiles();
      this.$refs.uploadHotKeyword.uploadFiles.length > 0 && this.$refs.uploadHotKeyword.clearFiles();
      this.$refs.uploadMonthStoreFee.uploadFiles.length > 0 && this.$refs.uploadMonthStoreFee.clearFiles();
      this.$refs.advertSpace.uploadFiles.length > 0 && this.$refs.advertSpace.clearFiles();
      this.$refs.uploadTemuInventory.uploadFiles.length > 0 && this.$refs.uploadTemuInventory.clearFiles();
      this.$refs.uploadAWDInventory.uploadFiles.length > 0 && this.$refs.uploadAWDInventory.clearFiles();
      this.$refs.uploadSalesTrafficReport.uploadFiles.length > 0 && this.$refs.uploadSalesTrafficReport.clearFiles();
      this.$refs.keywordSearchVolume.uploadFiles.length > 0 && this.$refs.keywordSearchVolume.clearFiles();
      this.$refs.xiYouSearchKeyword.uploadFiles.length > 0 && this.$refs.xiYouSearchKeyword.clearFiles();
    },
    createAdvert(row) {
      requestModules.createSingleAdvert({ asin: row.asin1 });
    },
    createAdvertBtn() {
      requestModules.createAdvert();
    },
    createKeywordBtn() {
      requestModules.autoCreateManaulKeywordAdvert();
    },
    getExportName() {
      return "库存规划表_" + new Date().format("yyyy-MM-dd_hh:mm:ss");
    },
    getAdvertName() {
      return "广告规划表_" + new Date().format("yyyy-MM-dd_hh:mm:ss");
    },
    getExportProductName() {
      return "产品描述_" + new Date().format("yyyy-MM-dd_hh:mm:ss");
    },
    productDetail(row) {
      window.open("/client/parentProductAnalysis?productType=" + row.productType);
    },
    goAdvert(row) {
      window.open("/client/advertMgmt?asin=" + row.asin1);
    },
    getData() {
      let params = { ...this.params };
      params.date = this.params.date.format("yyyy-MM-dd");
      requestModules.fetchData(params).then(res => {
        this.businessDataList = res.ldata;
        this.total = res.total;

        let businessDate = this.businessDataList[7].date;
        this.initDateList(businessDate);
      });
    },
    getExportData() {
      let params = {
        sku: "",
        sortKey: "speed",
        sortType: "1",
        // fulfillmentChannel: "AMAZON_NA",
        viewType: "1",
        productType: "",
        productColor: "",
        date: new Date(),
        listShowType: "3",
        productModel: "",
        beginIndex: 0,
        pageSize: 10000,
      };

      let hours = new Date().getHours();
      let offset = 0;
      let usaFirstHour = 16;
      Utils.isDaylightSavingTime() && (usaFirstHour = 15);
      hours < usaFirstHour && (offset = 1);
      if (hours < usaFirstHour) {
        params.date = new Date(new Date().getTime() - offset * 24 * 60 * 60 * 1000).format("yyyy-MM-dd");
      }

      requestModules.fetchData(params).then(res => {
        this.exportBusinessDataList = res.ldata;
      });
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getData();
    },
    getAdvertData() {
      requestModules
        .fetchAdverts({
          pageSize: 100000,
          Operation: "Update,Create",
          skipCount: 1,
          fields: "export",
        })
        .then(res => {
          this.advertData = res.ldata || [];
        });
    },
    createBtn() {
      requestModules
        .createBusinessData({})
        .then(() => {
          this.$confirm("生成完成", "提示", {
            confirmButtonText: "确定",
            type: "info",
          }).then(() => {});
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "操作失败",
          });
        });
    },
    initDateList(businessDate) {
      this.dateList = [];
      let dateLength = this.params.viewModel == 1 ? 8 : 30;
      if (businessDate) {
        for (let i = 0; i < dateLength; i++) {
          let date = new Date(new Date(businessDate) - i * 24 * 60 * 60 * 1000).format("MM-dd");
          this.dateList.push(date);
        }
      } else {
        let hours = new Date().getHours();
        let offset = 0;
        let usaFirstHour = 16;
        Utils.isDaylightSavingTime() && (usaFirstHour = 15);
        hours < usaFirstHour && (offset = 1);
        if (hours < usaFirstHour) {
          this.params.date = new Date(new Date().getTime() - offset * 24 * 60 * 60 * 1000);
        }

        for (let i = 0; i < dateLength; i++) {
          let date = new Date(new Date().getTime() - (i + offset) * 24 * 60 * 60 * 1000).format("MM-dd");
          this.dateList.push(date);
        }
      }
    },
    handleCellMouseEnter(row, column, cell, event) {
      this.activeRowIndex = cell.parentNode.rowIndex;
      this.activeColumnIndex = cell.cellIndex;
    },
    handleCellMouseLeave() {
      this.activeRowIndex = -1;
      this.activeColumnIndex = -1;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1 || index === 2) {
          sums[index] = "";
          return;
        }

        const values = data.map(item => Number(item["orderCount" + (index - 2)]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = 0;
        }
      });

      return sums;
    },
    getInventoryDayStyleClass(inventoryDay) {
      let styleClass = "";
      inventoryDay <= 15 && (styleClass = "redBg");
      inventoryDay > 15 && inventoryDay <= 30 && (styleClass = "yellowBg");
      inventoryDay > 30 && inventoryDay <= 90 && (styleClass = "greenBg");
      inventoryDay > 90 && (styleClass = "redText");
      return styleClass;
    },
    getAvailableInventoryDayStyleClass(inventoryDay) {
      let styleClass = "";
      inventoryDay <= 10 && (styleClass = "redBg");
      inventoryDay > 10 && inventoryDay <= 20 && (styleClass = "yellowBg");
      inventoryDay > 20 && inventoryDay <= 60 && (styleClass = "greenBg");
      inventoryDay > 60 && (styleClass = "redText");
      return styleClass;
    },
    getRecommendPriceStyleClass(row) {
      let styleClass = "";
      row.recommendPrice - row.price > 0 && (styleClass = "greenBg");
      row.recommendPrice - row.price < 0 && (styleClass = "redBg");
      return styleClass;
    },
    getInventoryAgeStyleClass(inventoryAge91To180Days) {
      let styleClass = "";
      inventoryAge91To180Days > 0 && (styleClass = "redBg");
      return styleClass;
    },
    getSellThroughStyleClass(sellThrough) {
      let styleClass = "";
      sellThrough < 1 && (styleClass = "redBg");
      sellThrough >= 1 && sellThrough <= 2 && (styleClass = "yellowBg");
      sellThrough > 2 && (styleClass = "greenBg");
      return styleClass;
    },
    prevBtnClick() {},
    nextBtnClick() {},
  },
  computed: {
    highlightCellStyle() {
      return {
        backgroundColor: "yellow",
      };
    },
    tableData() {
      // let totalOrder = {
      //   "seller-sku": "合计订单",
      //   "speed": "",
      //   "price": "",
      //   "inventoryCount": 0,
      //   "inboundQuantity": 0,
      //   "recommendCount": 0,
      //   "orderRate": 0,
      //   "last7DayCount": 0
      // };
      // let totalAmount = {
      //   "seller-sku": "合计金额",
      //   "speed": "",
      //   "price": "",
      //   "orderRate": -1
      // };
      // let totalGrossProfit = {
      //   "seller-sku": "合计毛利",
      //   "speed": "",
      //   "price": "",
      //   "orderRate": -1
      // };
      // let totalRefund = {
      //   "seller-sku": "合计退款",
      //   "speed": "",
      //   "price": "",
      //   "orderRate": -1
      // };
      // let totalAdSpend = {
      //   "seller-sku": "合计广告",
      //   "speed": "",
      //   "price": "",
      //   "orderRate": -1
      // };
      // let totalNetProfit = {
      //   "seller-sku": "合计净利",
      //   "speed": "",
      //   "price": "",
      //   "orderRate": -1
      // };
      // let totalProductVisit = {
      //   "seller-sku": "合计访客",
      //   "speed": "",
      //   "price": "",
      //   "orderRate": -1
      // };
      // for (let i = 1; i <= 31; i++) {
      //   totalOrder["orderCount" + i] = 0;
      //   totalAmount["orderCount" + i] = 0;
      //   totalGrossProfit["orderCount" + i] = 0;
      //   totalNetProfit["orderCount" + i] = 0;
      //   totalRefund["orderCount" + i] = 0;
      //   totalAdSpend["orderCount" + i] = 0;
      //   totalProductVisit["orderCount" + i] = 0;
      // }
      // let totalCount = 0;
      // let totalVisit = 0;
      // this.businessDataList.forEach((data, index) => {
      //   for (let i = 1; i < 31; i++) {
      //     if (this.params.productType == "" || data.productType == this.params.productType) {
      //       totalOrder["orderCount" + i] += Number(data["orderCount" + i]);
      //       totalAmount["orderCount" + i] += Number(data["orderPrice" + i]) * Number(data["orderCount" + i]);
      //       totalGrossProfit["orderCount" + i] += Number(data["grossProfit" + i]);
      //       totalNetProfit["orderCount" + i] += Number(data["netProfit" + i]);
      //       totalRefund["orderCount" + i] += Number(data["refund" + i]);
      //       totalAdSpend["orderCount" + i] += Number(data["adSpend" + i]);
      //       totalProductVisit["orderCount" + i] += Number(data["totalVisit" + i]);
      //     }
      //   }
      //   totalOrder.inventoryCount += Number(data.inventoryCount);
      //   totalOrder.inboundQuantity += Number(data.inboundQuantity);
      //   totalOrder.last7DayCount += Number(data.last7DayCount);
      //   totalOrder.recommendCount += Number(data.recommendCount) > 0 ? Number(data.recommendCount) : 0;

      //   totalCount += Number(data.totalCount);
      //   totalVisit += Number(data.totalVisit);
      // })
      // totalOrder.totalVisit = totalVisit;
      // totalOrder.orderRate = Math.round(totalCount / totalVisit * 10000) / 10000;

      // let sortKey = this.params.sortKey;
      // this.businessDataList.sort((a, b) => a[sortKey] == "∞" ? -1 : (this.params.sortType == 1 ? a[sortKey] - b[sortKey] : b[sortKey] - a[sortKey]));
      // let filterList = this.businessDataList.filter(item => {
      //   if (this.params.fulfillmentChannel != "") {
      //     return item["fulfillment-channel"] == this.params.fulfillmentChannel;
      //   } else {
      //     return true;
      //   }
      // });

      // let productMap = new Map();
      // let productList = [];
      // if (this.params.viewType == 2 || this.params.viewType == 3 || this.params.viewType == 4 || this.params.viewType == 5) {
      //   filterList.forEach(info => {
      //     let data = {};
      //     let key = info.productName;
      //     // this.params.viewType == 2 ? info.productName : info.productName + "-" + info.color
      //     this.params.viewType == 3 && (key = info.productName + "-" + info.color)
      //     this.params.viewType == 4 && (key = info.model)
      //     this.params.viewType == 5 && (key = info.productName + "-" + info.model)
      //     if (productMap.has(key)) {
      //       data = productMap.get(key);
      //       for (let i = 1; i < 31; i++) {
      //         data["orderCount" + i] += Number(info["orderCount" + i]);
      //         data["totalVisit" + i] += Number(info["totalVisit" + i]);
      //         data["grossProfit" + i] += Number(info["grossProfit" + i]);
      //         data["netProfit" + i] += Number(info["netProfit" + i]);
      //         data["refund" + i] += Number(info["refund" + i]);
      //         data["grossProfit" + i] += Number(info["grossProfit" + i]);
      //         data["adSpend" + i] += Number(info["adSpend" + i]).toFixed(2);
      //       }
      //     } else {
      //       data = { ...info };
      //     }
      //     data["availableQuantity"] += Number(info["availableQuantity"]);
      //     data["inboundQuantity"] += Number(info["inboundQuantity"]);
      //     data["inboundReceived"] += Number(info["inboundReceived"]);
      //     data["inboundShipped"] += Number(info["inboundShipped"]);
      //     data["inboundWorking"] += Number(info["inboundWorking"]);
      //     data["inventoryCount"] += Number(info["inventoryCount"]);
      //     data["reservedQuantity"] += Number(info["reservedQuantity"]);
      //     data["totalCount"] += Number(info["totalCount"]);
      //     data["totalOrder"] += Number(info["totalOrder"]);
      //     data["totalVisit"] += Number(info["totalVisit"]);
      //     data["last7DayCount"] += Number(info["last7DayCount"]);

      //     data["inventoryDay"] = Math.round(data["inventoryCount"] / data["last7DayCount"] * 7);
      //     data["availableInventoryDay"] = Math.round(data["availableQuantity"] / data["last7DayCount"] * 7);
      //     data["orderRate"] = Math.round(data["totalCount"] / data["totalVisit"] * 100) / 100;

      //     productMap.set(key, data);
      //   })
      //   productMap.forEach(product => productList.push(product));
      //   filterList = productList;
      // }

      // let blankReg = new RegExp(" ", 'igm')
      // console.log(this.params.productType, this.params.productColor)
      // this.params.productType != "" && (filterList = filterList.filter(product => product.productType == this.params.productType));
      // this.params.productColor != "" && (filterList = filterList.filter(product => product.color == this.params.productColor));
      // this.params.modelType != "" && (filterList = filterList.filter(product => product.model == this.params.modelType.replace(blankReg, "")));

      // let list = [totalProductVisit, totalOrder, totalAmount, totalGrossProfit, totalRefund, totalAdSpend, totalNetProfit, ...filterList];
      // list.forEach((item, index) => {
      //   item.sum = 0;
      //   for (let i = 1; i < 31; i++) {
      //     item.sum += item["orderCount" + i];
      //   }
      //   if (index > 0 && index < 7) {
      //     item.sum = item.sum.toFixed(2);
      //   }
      // })

      // for (let i = 1; i < 31; i++) {
      //   totalAmount["orderCount" + i] = totalAmount["orderCount" + i].toFixed(2);
      //   totalGrossProfit["orderCount" + i] = totalGrossProfit["orderCount" + i].toFixed(2);
      //   totalNetProfit["orderCount" + i] = totalNetProfit["orderCount" + i].toFixed(2);
      //   totalRefund["orderCount" + i] = totalRefund["orderCount" + i].toFixed(2);
      //   totalAdSpend["orderCount" + i] = totalAdSpend["orderCount" + i].toFixed(2);
      // }

      // return list;
      return this.businessDataList;
    },
    exportTitles() {
      let fields = {
        SKU: "seller-sku",
        名称: "productName",
        机型: "model",
        颜色: "productColorName",
        类型: "fulfillment-channel",
        增速: "speed",
        // "0~90日库存": "inventoryAge0To90Days",
        // "91~180日库存": "inventoryAge91To180Days",
        // "售出率": "sellThrough",
        // "90日订单": "unitsShippedT90",
        库存: "inventoryCount",
        可用: "availableQuantity",
        预留: "reservedQuantity",
        入库: "inboundQuantity",
        处理中: "inboundWorking",
        已发货: "inboundShipped",
        正在接收: "inboundReceived",
        库存天数: "inventoryDay",
        可用库存天数: "availableInventoryDay",
        合计访客: "totalVisit",
        排名: "rank",
        "30日订单": "sum",
        "7日订单": "last7DayCount",
        转化率: "orderRate",
        采购: "recommendCount",
        价格: "price",
        推荐: "recommendPrice",
        合计: "sum",
        "14日订单": "last14DayCount",
        "60日订单": "last60DayCount",
        "90日订单": "last90DayCount",
        售出率: "sellThrough",
        "0~30日库存": "inventoryAge0To30Days",
        "31~60日库存": "inventoryAge31To60Days",
        "61~90日库存": "inventoryAge61To90Days",
        "0~90日库存": "inventoryAge0To90Days",
        "91~180日库存": "inventoryAge91To180Days",
        上架日期: "openDate",
        产品状态: "status",
        Asin: "asin1",
        毛利: "netIncome",
        FBA费用: "fbaFee",
        店铺名称: "shopName",
        主推级别: "majorLevel",
      };

      this.dateList.forEach((date, index) => {
        fields[date + "销量"] = "orderItemsCount" + (index + 1);
      });
      this.dateList.forEach((date, index) => {
        fields[date + "价格"] = "orderPrice" + (index + 1);
      });
      return fields;
    },
    advertTitles() {
      let fields = {
        Product: "Product",
        Entity: "Entity",
        Operation: "Operation",
        "Campaign ID": "Campaign ID",
        "Ad Group ID": "Ad Group ID",
        "Portfolio ID": "Portfolio ID",
        "Ad ID": "Ad ID",
        "Keyword ID": "Keyword ID",
        "Product Targeting ID": "Product Targeting ID",
        "Campaign Name": "Campaign Name",
        "Ad Group Name": "Ad Group Name",
        "Campaign Name (Informational only)": "Campaign Name (Informational only)",
        "Ad Group Name (Informational only)": "Ad Group Name (Informational only)",
        "Portfolio Name (Informational only)": "Portfolio Name (Informational only)",
        "Start Date": "Start Date",
        "End Date": "End Date",
        "Targeting Type": "Targeting Type",
        State: "State",
        "Campaign State (Informational only)": "Campaign State (Informational only)",
        "Ad Group State (Informational only)": "Ad Group State (Informational only)",
        "Daily Budget": "Daily Budget",
        SKU: "SKU",
        "ASIN (Informational only)": "ASIN (Informational only)",
        "Eligibility Status (Informational only)": "Eligibility Status (Informational only)",
        "Reason for ineligibility (Informational only)": "Reason for ineligibility (Informational only)",
        "Ad Group Default Bid": "Ad Group Default Bid",
        "Ad Group Default Bid (Informational only)": "Ad Group Default Bid (Informational only)",
        Bid: "Bid",
        "Keyword Text": "Keyword Text",
        "Mother Tongue Keywords": "Mother Tongue Keywords",
        "Mother Tongue Region": "Mother Tongue Region",
        "Match Type": "Match Type",
        "Bidding Strategy": "Bidding Strategy",
        Placement: "Placement",
        Percentage: "Percentage",
        "Product Targeting Expression": "Product Targeting Expression",
        "Resolved Product Targeting Expression (Informational only)": "Resolved Product Targeting Expression (Informational only)",
        Impressions: "Impressions",
        Clicks: "Clicks",
        "Click-through": "Click-through",
        Rate: "Rate",
        Sales: "Sales",
        Orders: "Orders",
        Units: "Units",
        Conversion: "Conversion",
        Rate: "Rate",
        ACOS: "ACOS",
        CPC: "CPC",
        ROAS: "ROAS",
      };
      return fields;
    },
    orderTitles() {
      let fields = {
        SKU: "seller-sku",
        Price: "price",
        available: "available",
        "inbound-quantity": "inbound-quantity",
        last7DayOrder: "last7DayOrder",
        last30DayOrder: "last30DayOrder",
      };
      return fields;
    },
    updateAdvertData() {
      let list = this.advertData.filter(advert => advert.Operation != "");
      return list;
    },
    productTitles() {
      let fields = {
        sku: "sku",
        title: "title",
        des1: "des1",
        des2: "des2",
        des3: "des3",
        des4: "des4",
        des5: "des5",
      };
      return fields;
    },
    productData() {
      let list = [];
      // let { models, colors, desList, baseSku, title } = { ...this.exportProductInfo };
      let productConfigList = [SolidMagnetic, BorderDiamond, BaseSolid, BaseClear, BasicClear, MagnetStand, PeonyRose, OilPaints, ZebraStripe, WavyRipple, WaveGlitter, ReflectSliver, OilPaint, BasicMagnetic, PrettyFlower, FlowerBear, FashionJacket, DownJacket, PinkBear, FoldTinfoil];

      console.log(productConfigList);
      productConfigList.forEach(config => {
        let { models, colors, desList, baseSku, title } = { ...config };
        colors.forEach(color => {
          models.forEach(model => {
            let modelReg = new RegExp("_model_", "igm");
            let colorReg = new RegExp("_color_", "igm");
            let blankReg = new RegExp(" ", "igm");
            let info = {
              // sku: baseSku + color.replace(blankReg, "-") + "-" + model.replace(blankReg, ""),
              sku: color == "" ? baseSku + model.replace(blankReg, "") : baseSku + color.replace(blankReg, "-") + "-" + model.replace(blankReg, ""),
              title: title.replace(modelReg, model).replace(colorReg, color),
            };
            desList.forEach((des, index) => {
              info["des" + (index + 1)] = des.replace(modelReg, model).replace(colorReg, color);
            });
            list.push(info);
          });
        });
      });

      return list;
    },
    lowSaleTitles() {
      let fields = {
        店铺名称: "shopName",
        SKU: "seller-sku",
        建议售价: "recommandPrice",
        价格: "price",
        名称: "productName",
        机型: "model",
        颜色: "productColorName",
        "7日订单": "last7DayCount",
        "30日订单": "sum",
        "14日订单": "last14DayCount",
        "60日订单": "last60DayCount",
        "90日订单": "last90DayCount",
        库存: "inventoryCount",
        可用: "availableQuantity",
        预留: "reservedQuantity",
        入库: "inboundQuantity",
        处理中: "inboundWorking",
        已发货: "inboundShipped",
        库存天数: "inventoryDay",
        可用库存天数: "availableInventoryDay",
        排名: "rank",
        转化率: "orderRate",
        售出率: "sellThrough",
        "0~30日库存": "inventoryAge0To30Days",
        "31~60日库存": "inventoryAge31To60Days",
        "61~90日库存": "inventoryAge61To90Days",
        "0~90日库存": "inventoryAge0To90Days",
        "91~180日库存": "inventoryAge91To180Days",
        上架日期: "openDate",
        产品状态: "status",
        Asin: "asin1",
        毛利: "netIncome",
        FBA费用: "fbaFee",
      };
      return fields;
    },
    lowSaleData() {
      let dataList = [];
      this.exportBusinessDataList.forEach(data => {
        if (data.last7DayCount <= 0 && data.availableQuantity > 5 && data.status == "Active" && (data.inventoryAge31To60Days > 0 || data.inventoryAge61To90Days > 0 || data.inventoryAge91To180Days > 0)) {
          let info = { ...data };
          info.recommandPrice = (data.fbaFee + data.purchaseCost + 0.1 + 0.2) / 0.85;
          info.recommandPrice = (Math.floor(info.recommandPrice * 10) / 10 + 0.09).toFixed(2);
          dataList.push(info);
        }
      });
      return dataList;
    },
  },
};
</script>

<style lang="scss">
#BusinessMgmt {
  .header-box {
    text-align: left;
    line-height: 30px;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    height: 112px;

    .el-input,
    .el-select {
      width: 120px;
      margin-right: 20px;
      margin-left: 0px;
      padding: 0px 5px;
    }

    .el-button {
      width: 80px;
    }

    .header-line {
      margin-bottom: 20px;
    }

    .header-line:last-of-type {
      margin-bottom: 0px;
    }

    .small-margin-right {
      margin-right: 5px;
    }

    .header-label {
      display: inline-block;
      font-size: 16px;
      min-width: 65px;
      text-align: right;
    }

    .el-date-editor > input {
      padding-right: 0;
    }
  }
  .el-table .cell {
    padding-left: 2px;
    padding-right: 2px;
    line-height: 14px;
    text-align: right;

    .row-item {
      min-height: 14px;
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }
    .redText {
      color: red;
    }
    .greenText {
      color: red;
    }
    .greenYellowText {
      color: rgb(233, 104, 104);
    }
    .yellowText {
      color: rgb(112, 56, 56);
    }
  }

  .el-table tr:hover {
    background-color: #f9f981;
  }

  .el-table tr:hover td {
    background-color: transparent;
  }

  .el-table .current-row {
    background-color: #f9f981;

    .el-table__cell {
      background-color: #f9f981;
    }
  }

  .upload-demo {
    text-align: right;
  }
}
</style>
